"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStudentBasicDiagnostic = exports.getStudentFullDiagnosis = exports.getStudentDiagnosis = exports.getNextHierarchyId = exports.updateHistoryAndGetNextHierarchyIds = exports.loadHistoryAndGetNextHierarchyIds = exports.loadModuleHistory = exports.loadAllModulesHistory = exports.initAI = void 0;
var parametric_graph_1 = require("@evidenceb/parametric-graph");
var utils_1 = require("./utils");
var graph_manager_1 = require("./graph-manager");
/**
 * Returns an instance of the AI
 */
function initAI(AIClass, config, data, moduleId, adaptiveTestDiagnosis) {
    var params = (0, utils_1.getParamsFromConfigData)(config, data, moduleId);
    if (adaptiveTestDiagnosis)
        (0, graph_manager_1.initZpdesFromAdaptativeTest)(params, adaptiveTestDiagnosis);
    var graph = (0, parametric_graph_1.makeGraphFromData)(params, moduleId);
    return {
        error: false,
        historyLoaded: false,
        initiallyFresh: true,
        instance: new AIClass(params, graph),
        graph: graph,
    };
}
exports.initAI = initAI;
/**
 * Loads the module history for all modules for which the history was not
 * loaded yet. Returns the instances with the historyLoaded parameter set to
 * true if there was no error.
 * The error handlers allows to handle eror when loading one particular
 * module's history.
 */
function loadAllModulesHistory(aiCluster, history, errorCallback) {
    return Object.keys(aiCluster).reduce(function (loadedAICluster, moduleId) {
        var _a;
        return __assign(__assign({}, loadedAICluster), (_a = {}, _a[moduleId] = loadModuleHistory(aiCluster[moduleId], history[moduleId], errorCallback), _a));
    }, {});
}
exports.loadAllModulesHistory = loadAllModulesHistory;
/**
 * Loads the module history for a module for which the history was not
 * loaded yet. Returns the instance with the historyLoaded parameter set to
 * true if there was no error.
 * The error handlers allows to handle eror when the history.
 */
function loadModuleHistory(aiInfo, history, errorCallback) {
    if (aiInfo.historyLoaded) {
        return aiInfo;
    }
    else {
        try {
            (0, exports.loadHistoryAndGetNextHierarchyIds)(aiInfo.instance, history !== null && history !== void 0 ? history : []);
            return __assign(__assign({}, aiInfo), { historyLoaded: true, initiallyFresh: !history || history.length === 0 });
        }
        catch (err) {
            if (errorCallback)
                errorCallback(err);
            return __assign(__assign({}, aiInfo), { error: true });
        }
    }
}
exports.loadModuleHistory = loadModuleHistory;
/**
 * Loads the history for a bandit manchot and returns the next exercise to be
 * played
 */
var loadHistoryAndGetNextHierarchyIds = function (instance, history) {
    return instance.sample_from_history(history);
};
exports.loadHistoryAndGetNextHierarchyIds = loadHistoryAndGetNextHierarchyIds;
/**
 * Updates the history and returns the next exercise to be played
 */
var updateHistoryAndGetNextHierarchyIds = function (instance, historyItem) {
    return instance.sample_from_history([historyItem]);
};
exports.updateHistoryAndGetNextHierarchyIds = updateHistoryAndGetNextHierarchyIds;
/**
 * Returns the next exercise to be played
 */
var getNextHierarchyId = function (instance) {
    return instance.sample_from_history([]);
};
exports.getNextHierarchyId = getNextHierarchyId;
/**
 * Returns the student's basic diagnosis
 */
function getStudentDiagnosis(instance) {
    return instance.get_student_diagnosis();
}
exports.getStudentDiagnosis = getStudentDiagnosis;
/**
 * Returns the student's full diagnosis as provided by the bandit manchot
 */
function getStudentFullDiagnosis(instance) {
    return instance.get_full_diagnostic();
}
exports.getStudentFullDiagnosis = getStudentFullDiagnosis;
/**
 * For the Bandit Manchot
 * Returns a student's basic diagnostic, which corresponds to the percentage of
 * open objectives in the module and the average score over the last exercices
 * (also expressed as a percentage)
 */
function getStudentBasicDiagnostic(instance) {
    var diagnostic = instance.get_student_diagnosis();
    return {
        progression: Math.floor(diagnostic.graphe_coverage_rate * 100),
        averageScore: Math.floor(diagnostic.mean_student_score * 100),
    };
}
exports.getStudentBasicDiagnostic = getStudentBasicDiagnostic;
